import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import SEO from '../components/SEO';
import { Calendar, Users, Briefcase, Sparkles, MapPin, Clock, CalendarPlus } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Checkbox } from '../components/ui/checkbox';
import axios from 'axios';

const HERO_IMG = '/images/heritage-norfolk-sq.jpg';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Raw calendar data — dates are ISO so we can sort + group reliably.
// type: 'social' | 'business' | 'special'
const EVENTS = [
  { start: '2026-05-14', end: null, type: 'social', name: 'Pool & Darts Night', venue: 'Glossop town centre pub', startTime: '19:30', endTime: '21:30' },
  { start: '2026-05-28', end: null, type: 'business', name: 'Pre-Heritage Planning Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-05-29', end: '2026-05-31', type: 'special', name: 'Heritage Weekend', venue: 'Glossop', startTime: '09:00', endTime: '17:00' },
  { start: '2026-06-11', end: null, type: 'social', name: 'Bury Arcade Retro Gaming', venue: 'Arcade Club, Bury', startTime: '19:30', endTime: '21:30' },
  { start: '2026-06-25', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-06-26', end: '2026-06-28', type: 'special', name: 'Camping Weekend', venue: 'Peak District / TBC', startTime: '17:00', endTime: '12:00' },
  { start: '2026-07-09', end: null, type: 'social', name: 'BBQ & Games Night', venue: 'Manor Park / TBC', startTime: '19:30', endTime: '21:30' },
  { start: '2026-07-10', end: '2026-07-12', type: 'special', name: 'Woodland Games', venue: 'TBC', startTime: '17:00', endTime: '12:00', noIcs: true },
  { start: '2026-07-23', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-08-13', end: null, type: 'social', name: 'Bowling Night', venue: 'TBC (train accessible)', startTime: '19:30', endTime: '21:30' },
  { start: '2026-08-14', end: '2026-08-16', type: 'special', name: 'Family Camping Weekend', venue: 'TBC', startTime: '17:00', endTime: '12:00' },
  { start: '2026-08-27', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-09-10', end: null, type: 'business', name: 'Pre-Beer Festival Planning', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-09-18', end: '2026-09-19', type: 'special', name: 'Market Hall Beer Festival', venue: 'Glossop Market Hall', startTime: '17:00', endTime: '23:00' },
  { start: '2026-09-24', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-10-08', end: null, type: 'social', name: 'Curry Night + Drinks', venue: 'Glossop town centre', startTime: '19:30', endTime: '21:30' },
  { start: '2026-10-22', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-11-07', end: '2026-11-08', type: 'special', name: 'Manor Park Bonfire', venue: 'Manor Park, Glossop', startTime: '09:00', endTime: '22:00' },
  { start: '2026-11-12', end: null, type: 'social', name: 'Post Bonfire Social', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-11-26', end: null, type: 'business', name: 'Bonfire Donations Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2026-12-12', end: null, type: 'social', name: 'Christmas Social — Meal & Drinks', venue: 'Glossop / TBC', startTime: '19:30', endTime: '21:30' },
  { start: '2026-12-24', end: null, type: 'social', name: 'Pub Quiz Glossop', venue: 'TBC', startTime: '19:00', endTime: '20:00' },
  { start: '2027-01-14', end: null, type: 'social', name: 'Crystal Maze Manchester', venue: 'Crystal Maze Experience', startTime: '19:30', endTime: '21:30' },
  { start: '2027-01-28', end: null, type: 'business', name: 'GlossFest Kick-Off Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2027-02-11', end: null, type: 'social', name: 'Meet With Another Table', venue: 'TBC', startTime: '19:30', endTime: '21:30' },
  { start: '2027-02-25', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2027-03-11', end: null, type: 'social', name: 'Escape Room Manchester', venue: 'Manchester city centre', startTime: '19:30', endTime: '21:30' },
  { start: '2027-03-25', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
  { start: '2027-04-08', end: null, type: 'social', name: 'Driving Range / Golf + Drinks', venue: 'TBC (train accessible)', startTime: '19:30', endTime: '21:30' },
  { start: '2027-04-22', end: null, type: 'business', name: 'Monthly Business Meeting', venue: 'TBC', startTime: '19:00', endTime: '20:30' },
];

const TYPE_META = {
  social:   { label: 'Social',           icon: Users,      ring: 'ring-[#F0A500]/30', dot: 'bg-[#F0A500]',    text: 'text-[#B97400]', bg: 'bg-[#FEF7E6]' },
  business: { label: 'Business Meeting', icon: Briefcase,  ring: 'ring-[#0A0A0A]/15', dot: 'bg-[#0A0A0A]',    text: 'text-[#0A0A0A]', bg: 'bg-[#F4F4F5]' },
  special:  { label: 'Special Event',    icon: Sparkles,   ring: 'ring-[#D62F2F]/25', dot: 'bg-[#D62F2F]',    text: 'text-[#9A1F1F]', bg: 'bg-[#FDECEC]' },
};

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const WEEKDAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function parseLocalDate(iso) {
  // Treat ISO as local date (avoid TZ surprises)
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

function formatDateRange(event) {
  const start = parseLocalDate(event.start);
  if (!event.end) {
    return {
      dayNum: start.getDate(),
      weekday: WEEKDAY_NAMES[start.getDay()],
      label: null,
    };
  }
  const end = parseLocalDate(event.end);
  return {
    dayNum: start.getDate(),
    weekday: WEEKDAY_NAMES[start.getDay()],
    label: `→ ${end.getDate()} ${MONTH_NAMES[end.getMonth()].slice(0, 3)}`,
  };
}

function groupByMonth(events) {
  const groups = new Map();
  for (const e of events) {
    const d = parseLocalDate(e.start);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        title: `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`,
        events: [],
      });
    }
    groups.get(key).events.push(e);
  }
  return Array.from(groups.values());
}

// Build an .ics file body for a single event and trigger a download. Uses
// "floating" date-time (no TZID / no Z) so the calendar app interprets it in
// the user's own time zone — simplest and most compatible across Google /
// Apple / Outlook.
function pad(n) {
  return String(n).padStart(2, '0');
}

function toICSDateTime(isoDate, hhmm) {
  const [y, m, d] = isoDate.split('-').map(Number);
  const [hh, mm] = hhmm.split(':').map(Number);
  return `${y}${pad(m)}${pad(d)}T${pad(hh)}${pad(mm)}00`;
}

function eventToVEVENT(event, dtstamp) {
  const start = toICSDateTime(event.start, event.startTime);
  const endIso = event.end || event.start;
  const end = toICSDateTime(endIso, event.endTime);
  const slug = event.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
  const uid = `${event.start}-${slug}@glossoproundtable.org`;
  const summary = `Glossop Round Table — ${event.name}`;
  const description = `Event type: ${TYPE_META[event.type].label}\\nFind more at https://www.glossoproundtable.org/social-calendar`;
  return [
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${summary}`,
    `LOCATION:${event.venue}`,
    `DESCRIPTION:${description}`,
    'END:VEVENT',
  ];
}

function triggerDownload(icsBody, filename) {
  const blob = new Blob([icsBody], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function buildCalendarHeader() {
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Glossop Round Table 916//Social Calendar//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
  ];
}

function downloadEventICS(event) {
  const dtstamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const slug = event.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
  const ics = [
    ...buildCalendarHeader(),
    ...eventToVEVENT(event, dtstamp),
    'END:VCALENDAR',
  ].join('\r\n');
  triggerDownload(ics, `glossop-rt-${slug}.ics`);
}

function downloadAllEventsICS(events) {
  const dtstamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const lines = [...buildCalendarHeader(), 'X-WR-CALNAME:Glossop Round Table 2026/27', 'X-WR-CALDESC:Socials, business meetings and special events from Glossop & District Round Table 916'];
  for (const e of events) {
    if (e.noIcs) continue;
    lines.push(...eventToVEVENT(e, dtstamp));
  }
  lines.push('END:VCALENDAR');
  triggerDownload(lines.join('\r\n'), 'glossop-rt-social-calendar-2026-27.ics');
}

function EventCard({ event, idx }) {
  const meta = TYPE_META[event.type];
  const Icon = meta.icon;
  const { dayNum, weekday, label } = formatDateRange(event);

  return (
    <div
      data-testid={`calendar-event-${idx}`}
      className={`group flex gap-4 sm:gap-6 p-5 sm:p-6 bg-white border border-black/5 ring-1 ${meta.ring} hover:border-black/15 transition-colors`}
    >
      {/* Date block */}
      <div className="flex-shrink-0 text-center w-16 sm:w-20">
        <div className={`text-[10px] font-bold uppercase tracking-widest ${meta.text}`}>
          {weekday}
        </div>
        <div className="text-3xl sm:text-4xl font-bold text-[#0A0A0A] leading-none mt-1">
          {String(dayNum).padStart(2, '0')}
        </div>
        {label && (
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[#52525B] mt-1">
            {label}
          </div>
        )}
      </div>

      {/* Vertical divider */}
      <div className={`w-px ${meta.dot} self-stretch opacity-40 group-hover:opacity-80 transition-opacity`} />

      {/* Body */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-2">
          <span
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] sm:text-[11px] font-bold uppercase tracking-wider ${meta.bg} ${meta.text}`}
          >
            <Icon className="w-3 h-3" />
            {meta.label}
          </span>
          {event.noIcs ? (
            <span
              data-testid={`calendar-event-${idx}-prebooked`}
              className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] sm:text-[11px] font-bold uppercase tracking-wider text-[#52525B] border border-dashed border-black/15 flex-shrink-0"
              title="Pre-ticketed event — book through the organisers"
            >
              Pre-Ticketed
            </span>
          ) : (
            <button
              type="button"
              onClick={() => downloadEventICS(event)}
              data-testid={`calendar-event-${idx}-ics-btn`}
              aria-label={`Add ${event.name} to your calendar`}
              className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] sm:text-[11px] font-bold uppercase tracking-wider text-[#52525B] hover:text-[#F0A500] border border-black/10 hover:border-[#F0A500] transition-colors flex-shrink-0"
            >
              <CalendarPlus className="w-3 h-3" />
              <span className="hidden sm:inline">Add to calendar</span>
              <span className="sm:hidden">Add</span>
            </button>
          )}
        </div>
        <h3 className="text-base sm:text-lg font-bold text-[#0A0A0A] leading-snug mb-2">
          {event.name}
        </h3>
        <div className="flex flex-col sm:flex-row sm:items-center gap-x-5 gap-y-1 text-sm text-[#52525B]">
          <span className="inline-flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-[#A1A1AA]" />
            {event.venue}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5 text-[#A1A1AA]" />
            {event.startTime} &ndash; {event.endTime}
          </span>
        </div>
      </div>
    </div>
  );
}

function LegendItem({ type }) {
  const meta = TYPE_META[type];
  const Icon = meta.icon;
  return (
    <span
      data-testid={`calendar-legend-${type}`}
      className={`inline-flex items-center gap-2 px-3 py-1.5 ${meta.bg} ${meta.text} text-xs font-bold uppercase tracking-wider`}
    >
      <Icon className="w-3.5 h-3.5" />
      {meta.label}
    </span>
  );
}

export default function SocialCalendarPage() {
  const months = groupByMonth(EVENTS);
  // Build a flat index so each card has a unique data-testid across months
  let runningIdx = 0;

  // Counts for the intro stats
  const counts = EVENTS.reduce(
    (acc, e) => {
      acc[e.type] += 1;
      return acc;
    },
    { social: 0, business: 0, special: 0 }
  );

  return (
    <div data-testid="social-calendar-page">
      <SEO
        title="Social Calendar 2026"
        description="The 2026/27 social calendar for Glossop & District Round Table 916 — pool nights, retro gaming, camping weekends, Heritage Weekend, GlossFest, the Beer Festival, Bonfire Night and everything in between."
        path="/social-calendar"
        keywords={['Round Table calendar', 'Glossop Round Table events 2026', 'Glossop social events', 'Heritage Weekend 2026', 'Manor Park Bonfire 2026']}
      />

      <HeroSection
        image={HERO_IMG}
        title="Social Calendar"
        subtitle="May 2026 → April 2027 — twelve months of fun, friendship and fundraising"
        fullHeight={false}
        alt="Crowds enjoying an evening in Glossop's Norfolk Square during Heritage Weekend, with gazebos, bunting and festoon lights overhead"
        captionTag="Heritage Weekend 2026"
      />

      {/* Intro + legend */}
      <section className="py-16 sm:py-20 bg-white border-b border-black/5">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12 items-start">
            <div className="lg:col-span-2">
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] mb-4 block">
                What&apos;s on
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0A0A0A] mb-6">
                A year of Round Table life
              </h2>
              <p className="text-base text-[#52525B] leading-relaxed mb-4">
                From the first pool &amp; darts night in May right through to next year&apos;s golf evening, the 2026/27 calendar packs in everything we love — relaxed Thursday socials, monthly business meetings to keep things ticking, and the bigger weekends and signature events that put Glossop &amp; District Round Table on the map.
              </p>
              <p className="text-base text-[#52525B] leading-relaxed">
                If you&apos;re curious about Round Table, any of the social Thursdays are a great place to come along, say hello, and see what we&apos;re all about. Drop us a line via the{' '}
                <a href="/membership" className="text-[#F0A500] hover:text-[#D99500] font-semibold">Membership page</a> and we&apos;ll save you a seat.
              </p>

              {/* Membership eligibility — prevents ineligible folks turning up to socials */}
              <div data-testid="calendar-eligibility-callout" className="mt-6 p-5 bg-[#FEF7E6] border-l-4 border-[#F0A500]">
                <div className="text-xs font-bold uppercase tracking-widest text-[#0A0A0A] mb-2">
                  Who can join?
                </div>
                <p className="text-sm text-[#52525B] leading-relaxed mb-2">
                  Round Table is open to <strong>men, or those who identify as men, aged 18 to 45</strong>. If you&apos;re in the armed forces or a veteran, your first year is on us as part of our Armed Forces Covenant commitment.
                </p>
                <p className="text-sm text-[#52525B] leading-relaxed">
                  Socials are a no-pressure way to meet the team before joining &mdash; just drop us a quick line first so we know to look out for you.
                </p>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  onClick={() => downloadAllEventsICS(EVENTS)}
                  data-testid="calendar-download-all-btn"
                  className="btn-amber inline-flex items-center gap-2"
                >
                  <CalendarPlus className="w-4 h-4" />
                  Add the whole calendar
                </button>
                <span className="text-xs text-[#52525B]">
                  One <code className="text-[#0A0A0A] font-semibold">.ics</code> file, all 30 events &mdash; works with Google, Apple &amp; Outlook calendars.
                </span>
              </div>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F4F4F5] p-5 border-l-4 border-[#F0A500]">
                <div className="flex items-center gap-2 mb-1">
                  <Calendar className="w-4 h-4 text-[#F0A500]" />
                  <span className="text-xs font-bold uppercase tracking-widest text-[#0A0A0A]">By the numbers</span>
                </div>
                <div className="grid grid-cols-3 gap-2 mt-3 text-center">
                  <div>
                    <div className="text-2xl font-bold text-[#0A0A0A]">{counts.social}</div>
                    <div className="text-[10px] uppercase tracking-wider text-[#52525B] font-semibold">Socials</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#0A0A0A]">{counts.special}</div>
                    <div className="text-[10px] uppercase tracking-wider text-[#52525B] font-semibold">Weekends</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-[#0A0A0A]">{counts.business}</div>
                    <div className="text-[10px] uppercase tracking-wider text-[#52525B] font-semibold">Meetings</div>
                  </div>
                </div>
              </div>
              <div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#52525B] mb-2">Legend</div>
                <div className="flex flex-wrap gap-2">
                  <LegendItem type="social" />
                  <LegendItem type="special" />
                  <LegendItem type="business" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Calendar — grouped by month */}
      <section data-testid="calendar-list" className="py-16 sm:py-20 bg-[#FAFAFA]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-14">
            {months.map((month) => (
              <div key={month.key} data-testid={`calendar-month-${month.key}`}>
                <div className="sticky top-24 z-10 -mx-4 sm:-mx-6 lg:-mx-8 mb-6 px-4 sm:px-6 lg:px-8 py-3 bg-[#FAFAFA]/95 backdrop-blur-sm">
                  <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
                    {month.title}
                  </h2>
                  <div className="h-px bg-gradient-to-r from-[#F0A500] to-transparent mt-3" />
                </div>
                <div className="space-y-4">
                  {month.events.map((event) => {
                    const card = <EventCard key={`${event.start}-${event.name}`} event={event} idx={runningIdx} />;
                    runningIdx += 1;
                    return card;
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Monthly reminder signup */}
      <SocialsReminderSignup />

      {/* Closing CTA */}
      <section className="py-20 bg-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0A0A0A] mb-4">
            Fancy joining us?
          </h2>
          <p className="text-base text-[#52525B] mb-8">
            Every social Thursday is open to anyone considering Round Table. Come along, no pressure — just a drink, a chat and a chance to meet the team.
          </p>
          <a
            href="/membership"
            data-testid="calendar-join-cta-btn"
            className="btn-amber inline-block"
          >
            Get In Touch
          </a>
        </div>
      </section>
    </div>
  );
}

function SocialsReminderSignup() {
  const [form, setForm] = useState({ name: '', email: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [notRobot, setNotRobot] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await axios.post(`${API}/calendar-signup`, { ...form, consent: true });
      setSubmitted(true);
      setForm({ name: '', email: '' });
      setNotRobot(false);
    } catch (err) {
      if (err.response?.status === 409) {
        setError(err.response.data.detail || 'This email is already on the list.');
      } else {
        setError('Something went wrong. Please try again later.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section data-testid="calendar-reminder-section" className="py-20 sm:py-24 bg-[#0A0A0A] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {submitted ? (
          <div
            data-testid="calendar-reminder-success"
            className="p-8 border-l-4 border-[#F0A500] text-center"
          >
            <h3 className="text-2xl sm:text-3xl font-bold mb-3">You&rsquo;re on the list!</h3>
            <p className="text-base text-zinc-300">
              Check your inbox for a confirmation email. We&rsquo;ll drop you a friendly reminder once a month with what&rsquo;s coming up.
            </p>
          </div>
        ) : (
          <div className="border-l-4 border-[#F0A500] pl-6 sm:pl-8">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-2">
              Monthly Reminder
            </span>
            <h3 className="text-2xl sm:text-3xl font-bold mb-3">Never miss a social Thursday</h3>
            <p className="text-base text-zinc-300 leading-relaxed mb-6">
              Drop your details in and we&rsquo;ll send a single short email each month with what&rsquo;s coming up at Glossop Round Table &mdash; socials, weekends away and the bigger events. No spam, unsubscribe in one click.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-testid="calendar-reminder-form">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="calendar-name" className="text-sm text-zinc-300">Name</Label>
                  <Input
                    id="calendar-name"
                    name="name"
                    required
                    value={form.name}
                    onChange={handleChange}
                    data-testid="calendar-reminder-name-input"
                    className="bg-zinc-900 border-zinc-700 text-white mt-1"
                    placeholder="Jane Smith"
                  />
                </div>
                <div>
                  <Label htmlFor="calendar-email" className="text-sm text-zinc-300">Email</Label>
                  <Input
                    id="calendar-email"
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    data-testid="calendar-reminder-email-input"
                    className="bg-zinc-900 border-zinc-700 text-white mt-1"
                    placeholder="you@example.com"
                  />
                </div>
              </div>

              {error && (
                <p data-testid="calendar-reminder-error" className="text-sm text-red-400">{error}</p>
              )}

              <div className="flex items-center gap-3 p-3 bg-zinc-900 border border-zinc-700">
                <Checkbox
                  id="calendar-not-robot"
                  data-testid="calendar-reminder-not-robot-checkbox"
                  checked={notRobot}
                  onCheckedChange={(checked) => setNotRobot(checked === true)}
                  className="border-zinc-500 data-[state=checked]:bg-[#F0A500] data-[state=checked]:text-[#0A0A0A] data-[state=checked]:border-[#F0A500]"
                />
                <Label
                  htmlFor="calendar-not-robot"
                  className="text-sm font-medium text-zinc-200 cursor-pointer select-none"
                >
                  I&rsquo;m not a Robot
                </Label>
              </div>

              <button
                type="submit"
                disabled={submitting || !notRobot}
                data-testid="calendar-reminder-submit-button"
                className="w-full sm:w-auto px-8 py-3 bg-[#F0A500] hover:bg-[#d99400] disabled:opacity-50 disabled:cursor-not-allowed text-[#0A0A0A] font-bold uppercase tracking-wider text-sm transition-colors"
              >
                {submitting ? 'Adding you to the list…' : 'Email me each month'}
              </button>

              <p className="text-xs text-zinc-500 leading-relaxed">
                Membership is for men (or those who identify as men) aged 18&ndash;45 &mdash; but anyone is welcome to follow along. By signing up you consent to Glossop &amp; District Round Table 916 emailing you a monthly socials digest. See our{' '}
                <a href="/policies/data-protection" className="text-[#F0A500] hover:underline">privacy policy</a>.
              </p>
            </form>
          </div>
        )}
      </div>
    </section>
  );
}

